import React from 'react';

const PageNotFound = () => {
    const notfound = 404;
    return (
        <div>
            <h4 className='text-center m-2'>This page not found !!! {notfound} !!!</h4>
            <div className="card p-3 m-3">
                <p><b>Note:</b> This website is not yet complete. <br />There is still work to be done on many pages. <br />Currently in development mode. <br />However, at present all the information given on this website is correct.</p>

            </div>
        </div>
    );
};

export default PageNotFound;
